@if (pick) {
    <div class="betslip-digital-bet-pick-column-0">
        @if (!pickState || !pickState.isRemoved) {
            @switch (pick.resultStatus) {
                @case (resultedStateEnum.Open) {
                    <div class="betslip-pick__swap_button">
                        <bs-line-switcher-button [pick]="pick" />
                    </div>
                }
                @case (resultedStateEnum.Won) {
                    <div class="betslip-pick__edit-bet__success-icon">
                        <i class="betslip-icon theme-success-i"></i>
                    </div>
                }
                @case (resultedStateEnum.Canceled) {
                    <div class="betslip-pick__edit-bet__canceled-icon">
                        <i class="betslip-icon theme-remove-i"></i>
                    </div>
                }
                @case (resultedStateEnum.Lost) {
                    <div class="betslip-pick__edit-bet__lost-icon">
                        <i class="betslip-icon theme-close-i"></i>
                    </div>
                }
            }
        }
        <bs-digital-combo-prevention-indicator [pick]="pick" [betslipType]="betslipType" />
    </div>
    <div class="betslip-digital-bet-pick-column-1 {{ pickClass }}">
        <ng-container *ngTemplateOutlet="pickTemplate; context: { pick: pick, betslipType: betslipType, messages: messages }" />
        @if (pick.resultStatus === resultedStateEnum.Open) {
            <bs-digital-pick-odds [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat" />
        }
    </div>
    <div class="betslip-digital-bet-pick-column-2">
        @if (pickState.resultedState === resultedStateEnum.Open) {
            @if (!pickState.isRemoved) {
                <button ds-button-icon kind="tertiary" variant="flat" size="small" class="edit-pick-remove-button" (click)="removePick()">
                    <vn-icon title="{{ siteCore.betslip.messages.Delete }}" name="sports-edit-bet-delete" size="12" />
                </button>
            } @else {
                <button ds-button kind="tertiary" variant="outline" size="small" (click)="enablePick()">
                    {{ siteCore.betslip.editBet.undo }}
                </button>
            }
        }
    </div>
}
